
import { assessmentHasImagesOrComments } from '@/shared/helpers';
import globalConstants from '../../shared/globalConstants';
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import TrailerAssessment from '../../types/TrailerAssessment';
import TrailerAssessmentType from '../../types/TrailerAssessmentType';
import TrailerDamageLayout from './TrailerDamageLayout.vue';

export default defineComponent({
    components: { TrailerDamageLayout },
    data(): {
        type: keyof TrailerAssessment;
        subTypes: {
            kingpin: string;
            driverSide: string;
            passengerSide: string;
        };
        typeAssessment: TrailerAssessmentType | undefined;
    } {
        return {
            type: globalConstants.trailer.assessmentTypes
                .kingpinLanding as keyof TrailerAssessment,
            subTypes: {
                kingpin:
                    globalConstants.trailer.assessmentTypes.subTypes.kingpin,
                driverSide:
                    globalConstants.trailer.assessmentTypes.subTypes.driverSide,
                passengerSide:
                    globalConstants.trailer.assessmentTypes.subTypes
                        .passengerSide,
            },
            typeAssessment: undefined,
        };
    },
    created() {
        if (this.trailerAssessment)
            this.typeAssessment = this.trailerAssessment[this.type];
    },
    computed: {
        ...mapGetters({ trailerAssessment: 'trailerAssessment' }),
        kingpinSide(): string {
            return assessmentHasImagesOrComments(
                this.typeAssessment as TrailerAssessmentType,
                this.subTypes.kingpin
            )
                ? 'active'
                : '';
        },
        driverSide(): string {
            return assessmentHasImagesOrComments(
                this.typeAssessment as TrailerAssessmentType,
                this.subTypes.driverSide
            )
                ? 'active'
                : '';
        },
        passengerSide(): string {
            return assessmentHasImagesOrComments(
                this.typeAssessment as TrailerAssessmentType,
                this.subTypes.passengerSide
            )
                ? 'active'
                : '';
        },
    },
    methods: {
        enterKingpinSide(): void {
            this.$router.push({
                path: `kingpinAssessment/${this.subTypes.kingpin}`,
            });
        },
        enterDriverSide(): void {
            this.$router.push({
                path: `kingpinAssessment/${this.subTypes.driverSide}`,
            });
        },
        enterPassengerSide(): void {
            this.$router.push({
                path: `kingpinAssessment/${this.subTypes.passengerSide}`,
            });
        },
    },
});
